<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Наименование</label>
            <crm-input-text
              [(value)]="masterMilestone.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>
          <div class="field">
            <label class="font-medium">Цвет</label>
            <div class="flex align-items-end gap-3">
              <crm-color-picker
                [nullable]="true"
                [color]="masterMilestone.color"
                (colorChange)="onColorPickerChange($event)"></crm-color-picker>
              <div
                class="master-milestone-color-preview"
                [class.master-milestone-color-preview--empty]="!masterMilestone.color"
                [ngStyle]="masterMilestone.color ? { 'background-color': masterMilestone.color } : null"></div>
            </div>
            <div class="p-inputgroup crm-hex-inputgroup mt-2">
              <span class="p-inputgroup-addon">Hex</span>
              <crm-input-text
                [value]="masterMilestone.color ?? ''"
                (valueChange)="changeColor($event)"
                [isError]="$any(errors?.color)"
                class="w-full"></crm-input-text>
            </div>
            <small
              *ngIf="errors?.color"
              class="p-error">
              {{ errors.color | join }}
            </small>
          </div>

          <div
            *ngIf="masterMilestone.deleted"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удалена"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.MASTER_MILESTONE"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="projectMasterMilestoneService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveMasterMilestone()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !masterMilestone.deleted"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteMasterMilestone()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && masterMilestone.deleted"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreMasterMilestone()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
